import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Button,
    Typography,
    Alert,
    Container,
    CircularProgress,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../firebase';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function EmailVerifySuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading | success | error

    const oobCode = searchParams.get('oobCode');

    useEffect(() => {
        if (!oobCode) {
            setStatus('error');
            return;
        }

        applyActionCode(auth, oobCode)
            .then(() => setStatus('success'))
            .catch((err) => {
                console.error('Email verification failed:', err);
                setStatus('error');
            });
    }, [oobCode]);

    if (status === 'loading') {
        return (
            <Container component="main" maxWidth="sm">
                <Box sx={{ marginTop: 8, display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    return (
        <Container component="main" maxWidth="sm">
            <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Card sx={{ width: '100%', maxWidth: 440 }}>
                    <CardContent sx={{ p: 4 }}>
                        {status === 'success' ? (
                            <Box sx={{ textAlign: 'center' }}>
                                <CheckCircleIcon sx={{ fontSize: 56, color: 'success.main', mb: 2 }} />
                                <Typography variant="h5" gutterBottom>
                                    E-Mail-Adresse bestätigt
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                    Ihre E-Mail-Adresse wurde erfolgreich verifiziert.<br />
                                    Ihr Account wird nun von einem Litport Admin geprüft und freigegeben.<br />
                                    Sie erhalten eine Benachrichtigung sobald Ihr Account aktiv ist.
                                </Typography>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => navigate('/login')}
                                >
                                    Zur Anmeldung
                                </Button>
                            </Box>
                        ) : (
                            <Box sx={{ textAlign: 'center' }}>
                                <ErrorOutlineIcon sx={{ fontSize: 56, color: 'error.main', mb: 2 }} />
                                <Typography variant="h5" gutterBottom>
                                    Bestätigung fehlgeschlagen
                                </Typography>
                                <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
                                    Der Bestätigungslink ist ungültig oder bereits abgelaufen.<br />
                                    Bitte fordern Sie einen neuen Link über die Anmeldeseite an.
                                </Alert>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => navigate('/login')}
                                >
                                    Zur Anmeldung
                                </Button>
                            </Box>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
}
